module.exports = __webpack_public_path__ + "img/fancy@2x.c944f5f.webp";